import axios from 'axios';
import toastr from 'toastr'

// Gets the logged in user data from local session
const getLoggedInUser = () => {
    const user = localStorage.getItem('user');
    if (user)
        return JSON.parse(user);
    return null;
}

//is user is logged in
const isUserAuthenticated = () => {
    return getLoggedInUser() !== null;
}

// Register Method
const postFakeRegister = (url, data) => {
    return axios.post(url, data).then(response => {
        if (response.status >= 200 || response.status <= 299)
            return response.data;
        throw response.data;
    }).catch(err => {
        var message;
        if (err.response && err.response.status ) {
            switch (err.response.status) {
                case 404: message = "Sorry! the page you are looking for could not be found"; break;
                case 500: message = "Sorry! something went wrong, please contact our support team"; break;
                case 401: message = "Invalid credentials"; break;
                default: message = err[1]; break;
            }
        }
        throw message;
    });

}

// Login Method
const postFakeLogin = (url, data) => {
    return axios.post(url, data).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        throw err[1];
    });
}

// postForgetPwd
const postFakeForgetPwd = (url, data) => {
    return axios.post(url, data).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        throw err[1];
    });
}


// Login Method
const postJwtProfile = (url, data) => {
    return axios.post(url, data,{ headers: { Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6ImFkbWluIiwiYWRtaW4iOnRydWUsImp0aSI6ImQ2MTEwYzAxLWMwYjUtNDUzNy1iNDZhLTI0NTk5Mjc2YjY1NiIsImlhdCI6MTU5MjU2MDk2MCwiZXhwIjoxNTkyNTY0NjE5fQ.QgFSQtFaK_Ktauadttq1Is7f9w0SUtKcL8xCmkAvGLw'} }).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        throw err[1];
    });
}

const postFakeProfile = (url, data) => {
    return axios.post(url, data).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        throw err[1];
    });
}

// Register Method
const Register = (url, data) => {
    return axios.post(url, data).then(response => {
        if (response.status >= 200 || response.status <= 299)
            return response.data;
        throw response.data;
    }).catch(err => {
        var message;
        if (err.response && err.response.status ) {
            switch (err.response.status) {
                case 404: message = "Sorry! the page you are looking for could not be found"; break;
                case 500: message = "Sorry! something went wrong, please contact our support team"; break;
                case 401: message = "Invalid credentials"; break;
                default: message = err[1]; break;
            }
        }
        return err.response;
    });
}

// Login Method
const postJwtLogin = (url, data) => {
    return axios.post(url, data, { headers: { Accept: 'application/json', 'Content-Type': 'application/json' } }).then(response => {
        if (response.status === 400 || response.status === 500) throw response.data;
        return response;
    }).catch(err => {
        const message = (err && err.response && err.response.data && (err.response.data.errors && err.response.data.errors[0]))
            || (err && err.response && err.response.data && err.response.data.error)
            || err.message
            || 'Login failed';
        try { toastr.error(message, "Error"); } catch (_) {}
        throw message;
    });
}

// Logout Method
const deviseLogout = (url, headers) => {
    const config = {
        method: 'delete',
        url: url,
        headers: headers
    }
    return axios(config).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response;
        return response.data;
    }).catch(err => {
        toastr.error(err.response.data.errors[0],"Error")
        throw err[1];
    });
}

// postForgetPwd
const postJwtForgetPwd = (url, data) => {
    return axios.post(url, data).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response.data;
    }).catch(err => {
        toastr.error(err.response.data.errors[0],"Error")
        throw err[1];
    });
}

var getParams = function (url) {
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
};
let headers = getParams(window.location.href);
const passwordReset = (url, data) => {
    delete headers.config
    var config = {
        method: 'put',
        url: url,
        headers: headers,
        data: data
    }
    return axios(config).then(response => {
        if (response.status === 400 || response.status === 500)
            throw response.data;
        return response;
    }).catch(err => {
        toastr.error(err.response.data.errors[0],"Error")
        throw err[1];
    });
}

export { passwordReset, getLoggedInUser, deviseLogout, isUserAuthenticated, postFakeRegister, postFakeLogin,postFakeProfile, postFakeForgetPwd, Register, postJwtLogin, postJwtForgetPwd, postJwtProfile }